import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { Wave } from './wave';
import { UtilsService } from '../shared/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WaveService {

  private wave: any = null;

  constructor(private utils: UtilsService) {
  }

  async get(): Promise<Wave> {
    if (this.utils.isBrowser) {
      if (!this.wave) {
        const { Wavesurfer } = await import('./wavesurfer');
        this.wave = Wavesurfer;
      }
      return this.wave;
    }
    return new Wave();
  }

}
